module.exports = function(app) {
    app.directive('noProductsError', function() {
        return {
            restrict: 'A',
            templateUrl: 'coverage.appTemplate.html/chmhom/directives/coverage-summary/noProductsError'
        };
    });
};